"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixFloatingPointArtifacts = fixFloatingPointArtifacts;
function fixFloatingPointArtifacts(input) {
    const decimalToken = /(?<![A-Za-z0-9_$])([+-]?(?:\d+\.\d*|\.\d+)(?:[eE][+-]?\d+)?)(?![A-Za-z0-9_$])/g;
    return input.replace(decimalToken, (token) => correctDecimalToken(token));
}
function correctDecimalToken(token) {
    const m = /^([+-]?(?:\d+\.\d*|\.\d+))([eE][+-]?\d+)?$/.exec(token);
    if (!m || typeof m[1] !== 'string' || m[1].length === 0) {
        return token;
    }
    const mantissa = m[1];
    const exp = m[2] ?? '';
    const mm = /^([+-]?)(\d*)\.(\d*)$/.exec(mantissa);
    if (!mm) {
        return token;
    }
    let [, sign, intPart, fracPart] = mm;
    if (sign === undefined || intPart === undefined || fracPart === undefined) {
        return token;
    }
    const originalIntPartEmpty = intPart === '';
    if (intPart === '') {
        intPart = '0';
    }
    if (fracPart === '') {
        fracPart = '0';
    }
    const nineRun = /(9{10,})\d*$/.exec(fracPart);
    if (nineRun && typeof nineRun[1] === 'string' && nineRun[1].length > 0) {
        const cut = fracPart.search(/(9{10,})\d*$/);
        const head = fracPart.slice(0, cut);
        const bumped = bumpDecimalDigitString(intPart, head);
        if (!bumped) {
            return token;
        }
        const { newInt, newFracHead, carriedIntoInt } = bumped;
        if (carriedIntoInt && newFracHead === '') {
            return sign + stripLeadingPlusIfZero(newInt) + exp;
        }
        const finalInt = originalIntPartEmpty ? '' : newInt;
        return sign + finalInt + '.' + newFracHead + exp;
    }
    const zeroNoise = /(0{10,})([1-9]\d{0,2})$/.exec(fracPart);
    if (zeroNoise &&
        typeof zeroNoise[1] === 'string' &&
        zeroNoise[1].length > 0 &&
        typeof zeroNoise[2] === 'string' &&
        zeroNoise[2].length > 0) {
        const cut = fracPart.length - (zeroNoise[1].length + zeroNoise[2].length);
        const head = fracPart.slice(0, cut);
        const trimmedHead = trimRightZeros(head);
        if (trimmedHead === '' || /^0+$/.test(trimmedHead)) {
            return sign + stripLeadingPlusIfZero(intPart) + exp;
        }
        const finalInt = originalIntPartEmpty ? '' : intPart;
        return sign + finalInt + '.' + trimmedHead + exp;
    }
    return token;
}
function bumpDecimalDigitString(intPart, head) {
    if (head === '') {
        const newInt = addOneToDecimalString(intPart);
        return { newInt, newFracHead: '', carriedIntoInt: true };
    }
    const arr = head.split('');
    let i = arr.length - 1;
    while (i >= 0 && arr[i] === '9') {
        arr[i] = '0';
        i--;
    }
    if (i >= 0 && arr[i] !== undefined) {
        const currentChar = arr[i];
        if (currentChar !== undefined) {
            arr[i] = String.fromCharCode(currentChar.charCodeAt(0) + 1);
            return { newInt: intPart, newFracHead: trimRightZeros(arr.join('')), carriedIntoInt: false };
        }
    }
    const newFracHead = '1' + '0'.repeat(head.length);
    const trimmed = trimRightZeros(newFracHead);
    if (trimmed === '') {
        const newInt = addOneToDecimalString(intPart);
        return { newInt, newFracHead: '', carriedIntoInt: true };
    }
    return { newInt: intPart, newFracHead: trimmed, carriedIntoInt: false };
}
function addOneToDecimalString(digits) {
    if (!/^\d+$/.test(digits)) {
        return digits;
    }
    const arr = digits.split('');
    let i = arr.length - 1;
    while (i >= 0 && arr[i] === '9') {
        arr[i] = '0';
        i--;
    }
    if (i >= 0 && arr[i] !== undefined) {
        const currentChar = arr[i];
        if (currentChar !== undefined) {
            arr[i] = String.fromCharCode(currentChar.charCodeAt(0) + 1);
            return arr.join('');
        }
    }
    return '1' + arr.join('');
}
function trimRightZeros(s) {
    return s.replace(/0+$/u, '');
}
function stripLeadingPlusIfZero(s) {
    return /^0+$/.test(s) ? '0' : s;
}
//# sourceMappingURL=fix-floating-point-artifacts.js.map